// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2PNeX","content":"styles_content__15pit","checkbox":"styles_checkbox__2VwJZ","checkboxLabel":"styles_checkboxLabel__1ecNY"};